/**
 * plugins/vuetify.ts
 *
 * Framework documentation: https://vuetifyjs.com`
 */

// Styles
import "vuetify/styles";

// Composables
import { createVuetify } from "vuetify";
import { vuetifyDefaults } from "@/plugins/vuetifyDefaults";
import { aliases, mdi } from "vuetify/iconsets/mdi-svg";
import {
  mdiAccount,
  mdiAccountGroup,
  mdiAccountBox,
  mdiAccountDetails,
  mdiAccountMultiple,
  mdiAccountCircle,
  mdiAccountTie,
  mdiAccountMultipleOutline,
  mdiBriefcase,
  mdiMapMarker,
  mdiCalendar,
  mdiOpenInNew,
  mdiLock,
  mdiCodeJson,
  mdiLink,
  mdiChevronUp,
  mdiChevronDown,
  mdiChevronLeft,
  mdiChevronRight,
} from "@mdi/js";

// Define a standard light theme (default)
const lightTheme = {
  dark: false,
  colors: {
    primary: "#143D56",
    "primary-darken-1": "#1F5592",
    secondary: "#2C797D",
    "secondary-darken-1": "#018786",
    error: "#C4474F",
    info: "#2C679D",
    success: "#2C9B7D",
    warning: "#BF7900",
    "surface-light": "#f8f9fa",
  },
};

const darkTheme = {
  dark: true,
  colors: {
    primary: "#143D56",
    "primary-darken-1": "#1F5592",
    secondary: "#2C797D",
    "secondary-darken-1": "#018786",
    error: "#C4474F",
    info: "#2C679D",
    success: "#2C9B7D",
    warning: "#BF7900",
  },
};

// Custom theme for chat pages with Musk Mist background (RGB 249,179,164)
// https://www.cs.cmu.edu/~jbigham/pubs/pdfs/2017/colors.pdf
const chatTheme = {
  dark: false,
  colors: {
    background: "#F9B3A4",
    surface: "#F9B3A4",
    "surface-bright": "#F9B3A4",
    "surface-light": "#F9B3A4",
    "surface-variant": "#424242",
    "on-surface-variant": "#F9B3A4",
    primary: "#143D56",
    "primary-darken-1": "#1F5592",
    secondary: "#2C797D",
    "secondary-darken-1": "#018786",
    error: "#C4474F",
    info: "#2C679D",
    success: "#2C9B7D",
    warning: "#BF7900",
  },
};

// https://vuetifyjs.com/en/introduction/why-vuetify/#feature-guides
export default createVuetify({
  defaults: vuetifyDefaults,
  icons: {
    defaultSet: "mdi",
    aliases: {
      ...aliases,
      account: mdiAccount,
      accountGroup: mdiAccountGroup,
      accountBox: mdiAccountBox,
      accountDetails: mdiAccountDetails,
      accountMultiple: mdiAccountMultiple,
      accountCircle: mdiAccountCircle,
      accountTie: mdiAccountTie,
      accountMultipleOutline: mdiAccountMultipleOutline,
      briefcase: mdiBriefcase,
      mapMarker: mdiMapMarker,
      calendar: mdiCalendar,
      openInNew: mdiOpenInNew,
      lock: mdiLock,
      codeJson: mdiCodeJson,
      link: mdiLink,
      chevronUp: mdiChevronUp,
      chevronDown: mdiChevronDown,
      chevronLeft: mdiChevronLeft,
      chevronRight: mdiChevronRight,
    },
    sets: {
      mdi,
    },
  },
  theme: {
    defaultTheme: "light",
    themes: {
      light: lightTheme,
      dark: darkTheme,
      chat: chatTheme,
    },
  },
});
